import { useUserActiveOrganization } from "@/api";
import { TypographyMuted } from "@/components/typography/Muted";
import { Settings } from "@/components/ui/SettingsSection";
import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import RenameRow from "./RenameRow";
import SlugRow from "./SlugRow";

const OrganizationBasics = () => {
  const [flashNewSlug, setFlashNewSlug] = useState(false);
  const { activeOrganization, loading: loadingActiveOrganization } =
    useUserActiveOrganization();

  if (!activeOrganization && !loadingActiveOrganization)
    return (
      <div className="text-center my-20">
        <TypographyMuted className="italic tracking-wide text-brand-gray-300 dark:text-brand-gray-200">
          Something went wrong getting the organization information. Please try
          refreshing the page.
        </TypographyMuted>
      </div>
    );

  return (
    <AnimatePresence>
      <Settings.Section
        title="Basics"
        description="Your organization at a glance"
      >
        <RenameRow setFlashNewSlug={setFlashNewSlug} />
        <SlugRow flashNewSlug={flashNewSlug} />
      </Settings.Section>
    </AnimatePresence>
  );
};

export default OrganizationBasics;
